<div class="card custom-card">
  <div class="d-flex justify-content-between align-items-center p-2  p-md-3">
    <span class="main-header">Price trends</span>
    <div class="d-flex gap-2">
      <select class="form-select form-select-sm shadow-none custom-header-dropdown"
        [(ngModel)]="selectedSubfilter" (change)="onSubfilterChange($event)">
        @for (opt of subfilterOptions; track opt) {
          <option [value]="opt.value">
            {{ opt.label }}
          </option>
        }
      </select>

      @if (isBranchVisible) {
        <select class="form-select form-select-sm shadow-none custom-header-dropdown"
          [(ngModel)]="selectedBranch" (change)="onBranchChange($event)">
          <option value="">All Branches</option>
          @for (opt of branchList; track opt) {
            <option [value]="opt._id">
              {{ opt.name }}
            </option>
          }
        </select>
      }
    </div>
  </div>

  <div class="p-2 px-md-3 pt-0 position-relative">
    <!-- Loading -->
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center graph-state-container">
        <app-loader></app-loader>
      </div>
    }

    <!-- Error -->
    @if (!loading && errorMessage) {
      <div
        class="d-flex justify-content-center align-items-center text-danger graph-state-container text-center px-3">
        {{ errorMessage }}
      </div>
    }

    <!-- Content Area -->
    @if (!loading && !errorMessage && graph.data.length > 0) {
      <div>
        <!-- Desktop View -->
        <div class="d-none d-md-block inner-graph-container">
          <plotly-plot class="plotly-graph-dimensions" [data]="graph.data" [layout]="graph.layout"
            [config]="graph.config" [useResizeHandler]="true">
          </plotly-plot>
        </div>
        <!-- Mobile View -->
        <div class="d-block d-md-none mobile-trends-container">
          <div class="mobile-sub-heading mb-3">Average selling price (customer)</div>
          @for (item of trendsList; track item) {
            <div class="mobile-trend-row d-flex align-items-center mb-2">
              <div class="m-label me-2">{{item.label}}</div>
              <div class="m-track flex-grow-1 mx-2">
                <div class="m-fill green-fill" [style.width.%]="(item.value / maxValue) * 100"></div>
              </div>
              <div class="m-value ms-2 text-end">{{item.formattedValue}}</div>
            </div>
          }
        </div>
      </div>
    }

    <!-- Empty State -->
    @if (!loading && !errorMessage && graph.data.length === 0) {
      <div
        class="d-flex justify-content-center align-items-center text-muted graph-state-container">
        No data available for the selected period.
      </div>
    }
  </div>
</div>
